import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-package-name-dialog',
    imports: [
    FormsModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule
],
    templateUrl: './package-name-dialog.component.html',
    styleUrls: ['./package-name-dialog.component.scss']
})
export class PackageNameDialogComponent {
  packageName: string = '';

  readonly maxPackageNameLength = 100;

  constructor(private dialogRef: MatDialogRef<PackageNameDialogComponent>) { }

  get isConfirmDisabled(): boolean {
    return !this.packageName?.trim();
  }

  onConfirm(): void {
    if (this.isConfirmDisabled) {
      return;
    }

    this.dialogRef.close(this.packageName.trim());
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
